export const STORAGEKEY = {
  TOKEN: "token",
  SESSION_ID: "SESSION_ID",
  STORE_NAME: "storeName",
  TABLE_NO: "tableNo",
  QR_CODE: "QRCode",
  DINING_MODE: "selectiDineOption",
  SESSION_TIMEOUT: "sessionTimeout",
  WELCOME_BANNER: "welcomeBanner",
};
